module.exports = __webpack_public_path__ + "img/Wp_2074.cceef867.png";